import { container } from "@xcorejs/ui";

export const containerTheme = container({
  variants: {
    normal: {
      width: ["100%", "100%", "100%", "76.8rem", "102.4rem", "120rem", "132rem"]
    }
  }
});
